import message from "components/CustomMessage";
import { generateUUID } from "utils/uuid";

export function dataURLtoFile(dataurl: string, filename?: string): File {
  if (!filename) {
    filename = generateUUID();
  }

  const arr = dataurl.split(",");

  const mimeMatch = arr[0].match(/:(.*?);/);
  const mime = mimeMatch ? mimeMatch[1] : "application/octet-stream"; // fallback MIME type

  const bstr = atob(arr[1]);

  const n = bstr.length;
  const u8arr = new Uint8Array(n);

  for (let i = 0; i < n; i++) {
    u8arr[i] = bstr.charCodeAt(i);
  }

  return new File([u8arr], filename, { type: mime });
}

export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = () => {
      // reader.result is of type string | ArrayBuffer, but we expect it to be a string for data URL
      if (typeof reader.result === "string") {
        resolve(reader.result);
      } else {
        reject(new Error("Failed to convert file to base64 string."));
      }
    };

    reader.onerror = (error) => reject(error);
  });
}

export function isBlobURL(url: string): boolean {
  return new URL(url).protocol === "blob:";
}

export const removeNonPrintableUnicodeCharacters = (fileName: string): string =>
  fileName.replace(/[^\x20-\x7E]/g, "");

export const validateFileForUpload = (
  files: FileList | File[],
): File | undefined => {
  const file = files[0];
  const extension = file.name.split(".").pop();
  const fileSize = file.size / 1024 ** 2;

  if (file.name.length > 255) {
    message.error("File name exceeds 255 characters.");
    return;
  }

  if (extension && ["dll", "exe"].indexOf(extension) !== -1) {
    message.error("This type of file is not allowed.");
    return;
  }

  if (fileSize > 100) {
    message.error("File size should not be more than 100MB.");
    return;
  }

  return file;
};

export const getFileSizeString = (size: number): string => {
  const fSExt = ["Bytes", "KB", "MB", "GB"];
  let i = 0;
  while (size > 900) {
    size /= 1024;
    i++;
  }
  return Math.round(size * 100) / 100 + " " + fSExt[i];
};
